export default __webpack_public_path__ + "static/vision4-6fc8b0e6e91bdb5291208576fba2614d.png";